"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDate = void 0;
exports.isDate = (value) => value instanceof Date;
//# sourceMappingURL=is-date.js.map